import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable()
export class SeedFulfillmentService {
  constructor(public configService: ConfigService, public networkService: NetworkService) { }
  submitedItem = false;

  // Get Unsubmitted Draft List
  public getUnsubmittedDraftList(dashboardFilter) {
    return this.networkService.getRequest(this.configService.getUnsubmittedDraftUrl() + '?cropYear=' + dashboardFilter.cropYear);
  }
  // Get Submitted Request list
  public getSubmittedRequestList(dashboardFilter) {
    return this.networkService.getRequest(this.configService.getSubmittedRequestUrl() + '?cropYear=' + dashboardFilter.cropYear);
  }
  // Get DeliverTo data for DeliverTo dropdown
  public getDeliverToList(companyCode) {
    return this.networkService.getRequest(this.configService.getReleaseFilterDataUrl() + '?companyCode=' + companyCode);
  }
  // Get release order items
  public getReleaseOrderItems(shipToAccount, cropYear, branchPlant, computeOption) {
    return this.networkService.getRequest(this.configService.getReleaseOrderItemsUrl() + '?shipToAccount=' + shipToAccount + '&cropYear=' + cropYear + '&branchPlant=' + branchPlant + '&computeOption=' + computeOption);
  }
  // Get modify release order items
  public getModifyReleaseOrderItems(shipToAccount, cropYear, releaseId, branchPlant, computeOption) {
    return this.networkService.getRequest(this.configService.getModifyReleaseOrderItemsUrl() + '?shipToAccount=' + shipToAccount + '&cropYear=' + cropYear + '&releaseId=' + releaseId + '&branchPlant=' + branchPlant + '&computeOption=' + computeOption);
  }
  // Get item availability by lot
  public getSeedFulfillmentItemAvailabilityByLot(data: any) {
    return this.networkService.postRequest(this.configService.getSeedFulfillmentItemAvailabilityByLotUrl(), data);
  }
  // Add release item availability by lot
  public addReleaseItemsLot(data: any) {
    return this.networkService.postRequest(this.configService.addReleaseItemsLotUrl(), data);
  }
  // Compute pallet and seed weight
  public getPalletAndSeedWeight(data: any) {
    return this.networkService.postRequest(this.configService.getPalletAndSeedWeightUrl(), data);
  }
  // Add Dealer order
  public addUpdateReleaseOrder(data: any) {
    return this.networkService.postRequest(this.configService.addUpdateReleaseOrderUrl(), data);
  }
  // Delete order release
  public releaseOrderDelete(data: any) {
    return this.networkService.postRequest(this.configService.deleteReleaseItem(), data);
  }
  // Place JDE Order from Landing page
  public placeMutileJDEOrder(data: any) {
    return this.networkService.postRequest(this.configService.placeMultipleJDEOrderUrl(), data);
  }
  // Get release data
  public getReleaseObject(releaseId) {
    return this.networkService.getRequest(this.configService.getReleaseDataUrl() + '?releaseId=' + releaseId);
  }
  // Get filtered un submitted release order
  public getFilteredUnSubmittedReleaseOrder(data: any) {
    return this.networkService.postRequest(this.configService.getFilteredUnSubmittedReleaseOrderUrl(), data);
  }
  // Place single JDE order
  public placeJDEOrder(data: any) {
    return this.networkService.postRequest(this.configService.placeSingleJDEOrderUrl(), data);
  }
  // Get filtered submitted release order
  public getFilteredSubmittedReleaseOrder(data: any) {
    return this.networkService.postRequest(this.configService.getFilteredSubmittedReleaseOrderUrl(), data);
  }
  // get unsubmitted report
  public getUnSubmittedReport(data: any) {
    return this.networkService.postRequest(this.configService.getUnSubmittedReportUrl(), data);
  }
  // get submitted report
  public getSubmittedReport(data: any) {
    return this.networkService.postRequest(this.configService.getSubmittedReportUrl(), data);
  }
  // Get request type
  public getRequestType() {
    return this.networkService.getRequest(this.configService.getRequestTypeUrl());
  }
  // Get delivery instructions
  public getDeliveryInstructions(accountNumber, productLineId) {
    return this.networkService.postRequest(this.configService.getDeliveryInstructionsUrl() + '?accountNumber=' + accountNumber, productLineId);
  }
  // Get can item list for box items
  public getCanItemListForCbox() {
    return this.networkService.getRequest(this.configService.getCanItemListForCboxUrl());
  }
  // Get Request Date
  public getRequestDate(productLine, isBulk) {
    return this.networkService.getRequest(this.configService.getRequestdateUrl() + '?productLine=' + productLine + '&isBulk=' + isBulk);
  }
}
